import * as model from "@/model/quartz/QuartzSchedule";
import { newEntityStoreHelper } from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.QuartzSchedule(), newFilter)
    .withStates({
        moduleList: [],
        baseModuleUrl: process.env.VUE_APP_REPORT_API_URL + "adm-service"
    })
    .withActions({
        getAllModuleList(context) {
            context.dispatch("api/get", {
                url: context.state.baseModuleUrl + "/quartzSchedule/getAllModuleList"
            },
            { root: true })
            .then(function (data) {
                context.commit("setModuleList", data);
            })
        },
        runJob(context) {
            var requestMap = {};
            let rows = context.state.rows;
            for(var id of context.state.checkedItems) {
                let item = rows.filter(row => row['id'] == id);
                requestMap[item[0].module] = requestMap[item[0].module] == undefined ? id : (requestMap[item[0].module] + ",") + id;
            }
            
            for(let moduleName in requestMap) {
                var splits = context.state.baseModuleUrl.split("/")
                splits[splits.length - 1] = moduleName === 'admin' ? 'adm' : moduleName  + "-service"
                let requestUrl =  splits.join("/") + "/quartzSchedule/run?ids=" + requestMap[moduleName]

                context.dispatch("api/get", {
                    url: requestUrl
                },{ root: true }).then(function() {
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Run Job" + " Success {id=" + context.state.checkedItems.join(",") + "}",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, { root: true }).then(function() {
                        context.dispatch("base/MMFbackToList", "quartzSchedule", {root: true}).then(function () {
                            context.dispatch("base/MMFLoadRows", "quartzSchedule", {root: true});
                        });
                    })
                }).catch(function(){
                    context.dispatch("base/showWarning", {
                        userAlertWarningStr: "Run Job" + " Failed {id=" + context.state.checkedItems.join(",") + "}",
                        userAlertWarningVisible: true,
                    }, { root: true });
                    return;
                });
            }
        },
        pauseJob(context) {
            var requestMap = {};
            let rows = context.state.rows;
            for(var id of context.state.checkedItems) {
                let item = rows.filter(row => row['id'] == id);
                requestMap[item[0].module] = requestMap[item[0].module] == undefined ? id : (requestMap[item[0].module] + ",") + id;
            }
            
            for(let moduleName in requestMap) {
                var splits = context.state.baseModuleUrl.split("/")
                splits[splits.length - 1] = moduleName === 'admin' ? 'adm' : moduleName + "-service"
                let requestUrl =  splits.join("/") + "/quartzSchedule/pause?ids=" + requestMap[moduleName]

                context.dispatch("api/get", {
                    url: requestUrl
                },{ root: true }).then(function() {
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Pause Job" + " Success {id=" + context.state.checkedItems.join(",") + "}",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, { root: true }).then(function() {
                        context.dispatch("base/MMFbackToList", "quartzSchedule", {root: true}).then(function () {
                            context.dispatch("base/MMFLoadRows", "quartzSchedule", {root: true});
                        });
                    })
                }).catch(function(){
                    context.dispatch("base/showWarning", {
                        userAlertWarningStr: "Pause Job" + " Failed {id=" + context.state.checkedItems.join(",") + "}",
                        userAlertWarningVisible: true,
                    }, { root: true });
                    return;
                });
            }
        },
        resumeJob(context) {
            var requestMap = {};
            let rows = context.state.rows;
            for(var id of context.state.checkedItems) {
                let item = rows.filter(row => row['id'] == id);
                requestMap[item[0].module] = requestMap[item[0].module] == undefined ? id : (requestMap[item[0].module] + ",") + id;
            }
            
            for(let moduleName in requestMap) {
                var splits = context.state.baseModuleUrl.split("/")
                splits[splits.length - 1] = moduleName === 'admin' ? 'adm' : moduleName  + "-service"
                let requestUrl =  splits.join("/") + "/quartzSchedule/resume?ids=" + requestMap[moduleName]

                context.dispatch("api/get", {
                    url: requestUrl
                },{ root: true }).then(function() {
                    context.dispatch("base/showSuccess", {
                        userAlertSuccessStr: "Resume Job" + " Success {id=" + context.state.checkedItems.join(",") + "}",
                        dismissCountDown: 5,
                        userAlertSuccessVisible: false,
                    }, { root: true }).then(function() {
                        context.dispatch("base/MMFbackToList", "quartzSchedule", {root: true}).then(function () {
                            context.dispatch("base/MMFLoadRows", "quartzSchedule", {root: true});
                        });
                    })
                }).catch(function(){
                    context.dispatch("base/showWarning", {
                        userAlertWarningStr: "Resume Job" + " Failed {id=" + context.state.checkedItems.join(",") + "}",
                        userAlertWarningVisible: true,
                    }, { root: true });
                    return;
                });
            }
        }
    })
    .withMutations({
        setModuleList(state, moduleList) {
            state.moduleList = moduleList;
        },
        setEntity(state, entity) {
            var splits = state.baseModuleUrl.split("/")
            if(JSON.stringify(entity) == "{}") {
                splits[splits.length - 1] = "adm-service"
            }else {
                state.entity = entity;
                splits[splits.length - 1] = entity.module + "-service"
            }
            state.baseModuleUrl = splits.join("/")
        },
        setUrlFromModule(state, value) {
            var path = value;
            if(value === null) {
                path = "adm"
            }
            else if(value === 'production')
                path = "production"
            else if(value === 'admin')
                path = 'adm'
            var splits = state.baseModuleUrl.split("/")
            splits[splits.length - 1] = path + "-service"
            state.baseModuleUrl = splits.join("/")
        }
    })
    .buildStore()